import FroalaEditor from "froala-editor";
import align from 'froala-editor/js/plugins/align.min';
import charCounter from 'froala-editor/js/plugins/char_counter.min';
import {setTabAsClean, setTabAsDirty} from "../pages/survey/questions/attach-form-dirty";

export function attachFroalaEditor() {
    new FroalaEditor('.froala-editor', {
        key: process.env.MIX_FROALA_EDITOR_KEY,
        pasteDeniedTags: ['img','div'],
        imageUpload: false,
        pastePlain: true,
        pluginsEnabled: ['align', 'charCounter'],
        events: {
            'initialized': function () {
                const editor = this;
                editor.events.on('drop', function (dropEvent) {
                    dropEvent.preventDefault();
                    dropEvent.stopPropagation();

                    return false;
                });

                // if old element(textarea) has class is-invalid
                if (this.$oel[0].classList.contains('is-invalid')) {
                    this.$box[0].classList.add('froala-editor-error');
                }
                if (this.$oel[0].maxLength > -1) {
                    this.opts.charCounterMax = this.$oel[0].maxLength;
                    this.events.trigger("charCounter.update");
                }
                if (this.$oel[0].dataset.froala) {
                    let options = $(this.$oel[0]).data('froala');
                    for (let [option, value] of Object.entries(options)) {
                        this.opts[option] = value;
                    }
                }
                setTabAsClean(this.$box.closest('.tab-pane'));
            },
            'contentChanged': function () {
                this.$box.closest('.form-group').find('.invalid-feedback').remove();
                this.$box[0].classList.remove('froala-editor-error');
                setTabAsDirty(this.$box.closest('.tab-pane'));
            }
        }
    });
}

export function froalaSetContent(element, content) {
    let iterator = 0;
    // froala needs a couple of milliseconds to attach
    const interval = setInterval(() => {
        iterator++;
        if(!!element['data-froala.editor'].html) {
            element['data-froala.editor'].html.set(content);
            element.value = content;
            clearInterval(interval);
            setTabAsClean($(element).closest('.tab-pane'));
        }
        // wait maximum 4.5 seconds and break the loop
        if(iterator >= 45) {
            clearInterval(interval);
            setTabAsClean($(element).closest('.tab-pane'));
        }
    }, 100);
}
